<template>
  <hb-modal
    v-model="show"
    size="large"
    title="Upload List"
    @close="onClose"
    :footer-off="true"
  >
    <template v-slot:subheader>
      Download and upload upcoming rent change reports.
    </template>
    <template v-slot:content>
      <hb-form label="Upload Report">
        <v-row class="pa-2">
          <v-col>
            <span class="hb-text-night-light">
              <b>Note:</b>
            </span>
            <span class="hb-text-night-light">
              Make sure that the spreadsheet you are uploading is complete. If
              the spreadsheet passed validation, the information will
              automatically be pushed to Hummingbird and any further changes
              will need to be made inside Hummingbird.</span
            >
          </v-col>
        </v-row>
        <v-row class="ma-0">
          <v-col class="pa-0">
            <HbFileInput
              class="ma-4"
              v-model="files"
              placeholder="Select to Attach a File"
              :allowMultiple="allowMultiple"
            />
          </v-col>
        </v-row>
        <v-row class="ma-0">
          <hb-btn
            :disabled="uploadIsDisabled"
            :loading="loading"
            color="primary"
            @click="getAttachments(files)"
            >Upload</hb-btn
          >
        </v-row>
        <v-row class="ma-0">
          <span class="py-4 hb-text-night-light"
            >Last Uploaded: Feb 01, 2023 by John Doe</span
          >
        </v-row>
      </hb-form>
    </template>
  </hb-modal>
</template>

<script>
export default {
  name: "UploadList",
  data() {
    return {
      files: [],
    };
  },
  props: [
    "to",
    "subject",
    "from",
    "show",
    "onSend",
    "onClose",
    "getAttachments",
    "loading",
    "clearData",
    "allowMultiple",
  ],
  computed: {
    uploadIsDisabled() {
      return this.files.length ? false : true;
    },
  },
  watch: {
    // Watch the clear prop for changes
    clearData(newVal) {
      if (newVal) {
        this.files = []; // Call clearData when clear prop changes
      }
    },
  },
};
</script>

<style scoped>
.label-div {
  background-color: #f9fafb;
  height: 48px;
  color: #101318;
}
</style>
